<sabis-ngx-dialog [scTitle]="title">

  <div modal-body>
    <p *ngFor="let message of messages" style="word-break: break-word">
      {{ message }}
    </p>
  </div>
  <div modal-footer>
    <sabis-ngx-button *ngFor="let button of buttons" (click)="onActionButtonClick(button)">
      {{ button.name }}
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>
